import {
  mergeAttributes,
  Node,
} from '@tiptap/core'

export interface CaptionOptions {
  HTMLAttributes: Record<string, any>
}

export const Caption = Node.create<CaptionOptions>({
  name: 'caption',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  inline: false,

  content: 'inline*',

  group: 'caption',

  selectable: false,

  draggable: false,

  atom: true,

  addAttributes() {
    return { }
  },

  parseHTML() {
    return [
      {
        tag: 'p[caption]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(
        this.options.HTMLAttributes,
        HTMLAttributes,
        { class: 'caption' },
      ),
      0,
    ]
  },
})
